import type { SkillDef } from './types';

/**
 * Prestige skill tree. Bought with prestige points (earned by resetting), each
 * level applies a permanent multiplier that persists across prestiges.
 */
export const SKILLS: readonly SkillDef[] = [
  {
    id: 'richveins', name: 'Reiche Adern', icon: '⛰️', maxLevel: 25,
    baseCost: 1, costGrowth: 1.4,
    description: '+15% Abbau pro Stufe.',
    effect: { type: 'autoMult', value: 1.15 },
  },
  {
    id: 'hardbargain', name: 'Harter Handel', icon: '💰', maxLevel: 25,
    baseCost: 1, costGrowth: 1.4,
    description: '+15% Verkaufswert pro Stufe.',
    effect: { type: 'valueMult', value: 1.15 },
  },
  {
    id: 'goldentouch', name: 'Goldene Hand', icon: '✨', maxLevel: 15,
    baseCost: 2, costGrowth: 1.5,
    description: '+25% Klickkraft pro Stufe.',
    effect: { type: 'clickMult', value: 1.25 },
  },
  {
    id: 'overclock', name: 'Übertaktung', icon: '⚡', maxLevel: 15,
    baseCost: 3, costGrowth: 1.5,
    description: '+20% Energie pro Stufe.',
    effect: { type: 'energyMult', value: 1.2 },
    requires: { skill: ['richveins', 3] },
  },
  {
    id: 'magnate', name: 'Magnat', icon: '🏆', maxLevel: 10,
    baseCost: 8, costGrowth: 1.7,
    description: '+30% auf alles pro Stufe (global).',
    effect: { type: 'globalMult', value: 1.3 },
    requires: { skill: ['hardbargain', 5] },
  },
  {
    id: 'smelter', name: 'Meisterschmelzer', icon: '⚗️', maxLevel: 20,
    baseCost: 2, costGrowth: 1.45,
    description: '+20% Verhüttung pro Stufe.',
    effect: { type: 'smeltMult', value: 1.2 },
    requires: { skill: ['richveins', 2] },
  },
  {
    id: 'foreman', name: 'Obersteiger', icon: '🧑‍🏭', maxLevel: 20,
    baseCost: 2, costGrowth: 1.45,
    description: '+20% Arbeiter-Ausstoß pro Stufe.',
    effect: { type: 'workerMult', value: 1.2 },
  },
] as const;

export const SKILL_BY_ID: Record<string, SkillDef> = Object.fromEntries(
  SKILLS.map((s) => [s.id, s]),
);
